import React from 'react';
import type { RefObject } from 'react';

import { v4 as uuidv4 } from 'uuid';

import Konva from 'konva';

import { FlexBox } from '@eltoro-ui/components';

import type { ButtonElement, CanvasElement, TextElement } from 'Components/CanvasEditor/types';

type TextExampleType = {
  id: string;
  title: string;
  props:
    | Pick<TextElement, 'text' | 'fontSize'>
    | Pick<ButtonElement, 'text' | 'fontSize' | 'background' | 'cornerRadius'>;
};

const textExamples: TextExampleType[] = [
  {
    id: 'header',
    title: 'Create Header',
    props: {
      text: 'Header',
      fontSize: 44,
    },
  },
  {
    id: 'sub-header',
    title: 'Create sub header',
    props: {
      text: 'Sub Header',
      fontSize: 28,
    },
  },
  {
    id: 'body-text',
    title: 'Create body text',
    props: {
      text: 'Body Text',
      fontSize: 18,
    },
  },
  {
    id: 'text-button',
    title: 'Create button',
    props: {
      text: 'Button',
      fontSize: 24,
      background: '#3B82F6',
      cornerRadius: 14,
    },
  },
];

interface TextProps {
  stageRef: RefObject<Konva.Stage>;
  onAddElement: (element: CanvasElement) => void;
}

export default function Text({ stageRef, onAddElement }: TextProps) {
  const onAddText = (props: TextExampleType['props']) => () => {
    const stage = stageRef.current;
    if (!stage) return;

    const x = (stage.width() - 200) / 2;
    const y = (stage.height() - props.fontSize) / 2;

    onAddElement({
      id: uuidv4(),
      type: 'text',
      fontSize: props.fontSize,
      text: props.text,
      width: 200,
      x,
      y,
      align: 'center',
      fontFamily: 'Arial',
      fill: '#000000',
      rotation: 0,
      draggable: true,
      scaleX: 1,
      scaleY: 1,
      visible: true,
      ...('background' in props
        ? {
            background: props.background,
            cornerRadius: props.cornerRadius,
          }
        : {}),
    });
  };

  return (
    <FlexBox flexDirection="column" gap="0.75rem" UNSAFE_className="element-examples-container">
      <span className="section-title">Text Presents</span>
      <FlexBox flexDirection="column" gap="0.75rem">
        {textExamples.map(({ id, title, props }) => (
          <button key={id} id={id} className="add-text-button" onClick={onAddText(props)}>
            {title}
          </button>
        ))}
      </FlexBox>
    </FlexBox>
  );
}
